<div id="ticketBasketRaffleAllocationList">
    <app-header title=""></app-header>
    <div class="paybee-modal-header paybee-modal-header--regular" style="border:none;">
        <div class="px-3 pt-5 mb-4">
            <div class="paybee-modal-header__regular">
                <div class="mb-4">
                    <a style="color: RGB(0, 118, 255);cursor:pointer;" [routerLink]="['/manage/tickets-and-guests/campaign', ticketsAndGuestsStateService.selectedCampaignId]" fragment="ticketsTab">← Back to Tickets</a>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12">
                    <div class="ticket-summary__holder headline-5 mb-2" id="holderName">Holder Name</div>
                    <div class="ticket-summary__type body-1 grey-text" id="ticketType">Ticket Type</div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body" id="ticketBasketRaffleAllocationListContent">
        <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular-important py-0 mx-n3 mt-n3" style="padding: 0px calc(19.2px + 16px) !important;" role="tablist">
            <li class="nav-item">
                <a class="nav-link active px-0 mr-4" id="ticketBasketRaffleAllocationListTabNav" data-toggle="tab" href="#ticketBasketRaffleAllocationListTab" role="tab" aria-controls="ticketBasketRaffleAllocationListTab"
                   aria-selected="true">Allocations</a>
            </li>
        </ul>
        <div class="tab-content pt-5">
            <div class="tab-pane fade show active" id="ticketBasketRaffleAllocationListTab" role="tabpanel" aria-labelledby="ticketBasketRaffleAllocationListTabNav">
                <div id="allocations-section" class="py-4">
                    <div id="select-allocations-section" class="d-none align-items-center justify-content-end">
                        <button id="selectAllocationsButton" class="btn btn--paybee btn--green button" style="min-width: 125px;">Change Allocations...</button>
                    </div>
                    <div id="allocation-list" class="d-none confirmed-guests-list mt-3">
                        <div id="allocation-list-container" class="confirmed-guests-list__body">
                        </div>
                    </div>
                    <div id="empty-item-list" class="d-none invitation-list mt-3">
                        <div class="d-flex flex-column align-items-center my-5">
                            <i class="fas fa-shopping-basket"></i>
                            <div class="headline-5 mb-2">Allocations</div>
                            <div class="body-2 mb-4 d-flex flex-column align-items-center">
                                <div class="mb-1">Basket raffle items have not been added yet. Try selecting allocations after adding items.</div>
                                <div class="mb-1">Use the button below to <span class="green-text">Select Allocations</span> to this ticket.</div>
                            </div>
                            <button id="selectAllocationsButton2" class="btn btn--paybee btn--green button disabled" style="min-width: 125px;">Select Allocations...</button>
                        </div>
                    </div>
                    <div id="empty-allocation-list" class="d-none invitation-list mt-3">
                        <div class="d-flex flex-column align-items-center my-5">
                            <i class="fas fa-shopping-basket"></i>
                            <div class="headline-5 mb-2">Allocations</div>
                            <div class="body-2 mb-4 d-flex flex-column align-items-center">
                                <div class="mb-1">You have no allocations yet.</div>
                                <div class="mb-1">Use the button below to <span class="green-text">Select Allocations</span> to this ticket.</div>
                            </div>
                            <button id="selectAllocationsButton2" class="btn btn--paybee btn--green button" style="min-width: 125px;">Select Allocations...</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
